import { useSortable } from '@dnd-kit/sortable'

interface JigsawPieceProps {
  imageSrc: string
  position: number
  id: number
}

export function JigsawPiece({
  imageSrc,
  position,
  id,
  ...rest
}: JigsawPieceProps) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id,
      transition: {
        duration: 500,
        easing: 'cubic-bezier(1, 1, 0, 1)'
      }
    })

  const style: React.CSSProperties = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        transition
      }
    : undefined

  return (
    <div ref={setNodeRef} {...listeners} {...attributes} {...rest}>
      <img
        src={imageSrc}
        style={style}
        alt={`Puzzle piece ${position}`}
        className="block w-full h-full object-cover select-none"
        draggable={false}
      />
    </div>
  )
}
